import React from 'react';
import { PageHeader } from "../../../components";

export default function HONCOUNCILMEMBER() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_COUNCI_MEMBER.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">Arc. Ashiru Tokunbo.</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                   ARC. ABIODUN SHONIBARE. is a licensed archictect, computational design specialist, and AI enthusiast with over a decade of experience working at the avant-garde intersection of archictecture and industrial design, spanning archictecture, furniture, installations and product design. He is an Associate Partner at Studio Stoone Designs and Directorat at ShiftLag, where he consults for organizations and delivers services and training in algorithmic design, complex geometry, and digital fabrication.
                   Beyond his professional practice, Abiodun is commited to knowledge sharing, mentorship and community development. He actively supports initiatives that promote education, creativity, sports and youth engagement while contributing to the growth and development of organizations through strategic planning, project oversight, and stakeholder collaboration.
                   He currently serves as Chair of the Education Committee of the Interior Designers Association of Nigeria IDAN.

                   As a member of the Management council of Lagos Country Club, he brings a blend of professional expertise, leadership experience, and a forward-thinking approach to supporting the club's continued growth, facilities development and service excellence.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
